import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import moment from 'moment';
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {MUISortOptions} from "mui-datatables";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloUserProfileAuth} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
import ApolloMasterBillingEdit from "../../organism/MASTER/Apollo_MasterBillingResourceEdit";
import ApolloMasterReferenceModal from "../../molecule/MASTER/Apollo_MasterReferenceModal";
import {ApolloDeleteButton} from "../../molecule/MASTER/Apollo_DeleteButton";
import {ApolloContext} from "../../atom/Apollo_Context";
import {LogData, ApolloEventRecord} from "../../atom/Apollo_EventRecord";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_BILLING_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import {
  apollo_billing_resource_master_relation_path,
  apollo_billing_resource_path,
  masterproducts_path,
  masterindustorys_path,
  masterbillingresources_path,
} from "../../atom/Apollo_links";
import {
  BillingResourceMasterRelation,
} from "./MasterModel";

import {Card, Grid, Typography, Button, IconButton} from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';
import {CsvData, MasterBillingResourceColumns} from "../../common/Apollo_CommonConst";

/*
    画面名：請求リソースマスタ一覧画面
 */
export default function MasterBillingResources() {
  const classes = apollo_useStyles();
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [rows, setRows] = useState<BillingResourceMasterRelation[]>([]);
  const {state: apolloContex} = React.useContext(ApolloContext);
  // 登録・変更に引き継ぐ請求リソースID
  const [billingId, setBillingId] = useState(0);
  // 再読み込みフラグ
  const [read, setRead] = useState(false);
  // 参照モーダル
  const [referenceOpen, setReferenceOpen] = useState<boolean>(false);
  const [clickedReferenceBillingId, setClickedReferenceBillingId] = useState<number>(0)

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "billingId",
    direction: 'asc',
  })
  const [numberOfRows, setNumberOfRows] = useState(10)

  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // 請求リソースマスタ取得
    const url = apollo_billing_resource_master_relation_path;
      ApolloAxios.get(url).then(response => {
        if (response.data.resultCode === 0) {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false,
            }
          });
          setRows(response.data.result);
        } else {
          console.log(response.data.message);
          setmsg({
            type: "all",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_MASTER_BILLING_LIST,"E","0"),
              loading: false
            }
          });
          setRows(response.data.result);
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_LIST,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
        setRows([]);
      });
  }, [read]);

  // リストカラム定義
  const columns = [
    {
      name: "billingId",
      label: "請求リソースID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "billingName",
      label: "請求リソース名称",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "creditLimitAmount",
      label: "与信限度額",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          align: "right",
        }),
        customBodyRender: (num: number) => {
          return "￥" + Number(num ? num : 0).toLocaleString();
        },
      }
    },
    {
      name: "",
      label: "アカウントグループ情報",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ style: { minWidth: "8rem" }, align: "center"}),
        customBodyRenderLite: (idx: number) => {
          if (rows[idx].accountgroupCount > 0) {
            return (
            <IconButton aria-label="delete" onClick={() => {
              setReferenceOpen(true);
              setClickedReferenceBillingId(rows[idx].billingId ?? 0)
            }}>
              <ChatIcon />
            </IconButton>
            )
          }
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        options: {
          setCellProps: () => ({
            align: "center"
          }),
        },
        customBodyRenderLite: (idx: number) => {
          return (
            <Button
              className={classes.buttonTop}
              variant={"contained"}
              color={"primary"}
              onClick={() => handleClickEditOpen(rows[idx].billingId)}
            >
              編集
            </Button>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ style: { minWidth: "8rem" }, align: "center"}),
        customBodyRenderLite: (idx: number) => {
          if (rows[idx].accountgroupCount === 0) {
            return (
              <ApolloDeleteButton handleDelete={handleDelete} title="請求リソース削除" text={`この請求リソースを削除しますか？`} id={rows[idx].billingId} />
            );
          }
        },
      },
    },
  ];

  // 編集ボタンハンドラ
  const handleClickEditOpen = (billingId: number) => {
    setBillingId(billingId);
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
  }

  // クローズボタンハンドラ
  const handleClickEditClose = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
  }
    
  // 請求リソースマスタ削除ハンドラ
  const handleDelete = async (billingId: number) => {
    // URL
    const url = apollo_billing_resource_path + "/" + billingId;
    var executeLogData: LogData = {
      eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute", // ログ種別 実行：execute, 結果：result
      result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
      userID: apolloContex.userprofile.userId,
      userName:  apolloContex.userprofile.userName,
      accessToken:  apolloContex.accesstoken,
      displayName: "請求リソースマスタ画面",
      category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
      actionType: "削除",
      accountGroupID: apolloContex.current.accountGroupId,
      accountGroupName: apolloContex.current.accountGroupName,
      accountID: apolloContex.current.accountId,
      accountName: apolloContex.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      targetID: billingId.toString(), // 操作を行うデータのID 実行時は空文字
      targetName: "", // 操作を行うデータの名称 実行時は空文字
      menu: "",
      itemList: []
    };

    ApolloEventRecord(executeLogData);

    // 請求リソースマスタ削除
    ApolloAxios.delete(url).then(response => {
      if (response.data.resultCode === 0) {
        var resultLogData: LogData = {
          eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
          logType: "result", // ログ種別 実行：execute, 結果：result
          result: "成功", // 実行結果 成功 / 失敗 ※実行時は空文字
          userID: apolloContex.userprofile.userId,
          userName:  apolloContex.userprofile.userName,
          accessToken:  apolloContex.accesstoken,
          displayName: "請求リソースマスタ画面",
          category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
          actionType: "削除",
          accountGroupID: apolloContex.current.accountGroupId,
          accountGroupName: apolloContex.current.accountGroupName,
          accountID: apolloContex.current.accountId,
          accountName: apolloContex.current.accountName,
          campaignID: "", // キャンペーンID
          campaignName: "", // キャンペーン名
          adGroupID: "", // 広告グループID
          adGroupName: "", // 広告グループ名
          targetID: billingId.toString(), // 操作を行うデータのID 実行時は空文字
          targetName: "", // 操作を行うデータの名称 実行時は空文字
          menu: "",
          itemList: []
        };
    
        ApolloEventRecord(resultLogData);

        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_MASTER_BILLING_LIST,"I","0"),
          }
        });
        // 呼び出し元・再読み込み
        setRead(!read);
      } else {
        var resultErrorLogData: LogData = {
          eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
          logType: "result", // ログ種別 実行：execute, 結果：result
          result: "失敗", // 実行結果 成功 / 失敗 ※実行時は空文字
          userID: apolloContex.userprofile.userId,
          userName:  apolloContex.userprofile.userName,
          accessToken:  apolloContex.accesstoken,
          displayName: "請求リソースマスタ画面",
          category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
          actionType: "削除",
          accountGroupID: apolloContex.current.accountGroupId,
          accountGroupName: apolloContex.current.accountGroupName,
          accountID: apolloContex.current.accountId,
          accountName: apolloContex.current.accountName,
          campaignID: "", // キャンペーンID
          campaignName: "", // キャンペーン名
          adGroupID: "", // 広告グループID
          adGroupName: "", // 広告グループ名
          targetID: billingId.toString(), // 操作を行うデータのID 実行時は空文字
          targetName: "", // 操作を行うデータの名称 実行時は空文字
          menu: "",
          itemList: []
        };
    
        ApolloEventRecord(resultErrorLogData);

        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MASTER_BILLING_LIST,"E","1"),
          }
        });
      }
    }).catch(err => {
      var resultErrorLogData: LogData = {
        eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result", // ログ種別 実行：execute, 結果：result
        result: "失敗", // 実行結果 成功 / 失敗 ※実行時は空文字
        userID: apolloContex.userprofile.userId,
        userName:  apolloContex.userprofile.userName,
        accessToken:  apolloContex.accesstoken,
        displayName: "請求リソースマスタ画面",
        category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
        actionType: "削除",
        accountGroupID: apolloContex.current.accountGroupId,
        accountGroupName: apolloContex.current.accountGroupName,
        accountID: apolloContex.current.accountId,
        accountName: apolloContex.current.accountName,
        campaignID: "", // キャンペーンID
        campaignName: "", // キャンペーン名
        adGroupID: "", // 広告グループID
        adGroupName: "", // 広告グループ名
        targetID: billingId.toString(), // 操作を行うデータのID 実行時は空文字
        targetName: "", // 操作を行うデータの名称 実行時は空文字
        menu: "",
        itemList: []
      };
  
      ApolloEventRecord(resultErrorLogData);

      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_LIST,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }
    
  // データリスト表示オプション
  const options = {
    filter: true,
    downloadOptions: {
      filename: `master_billingResources.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, rows);
      return "\uFEFF" + buildHead(MasterBillingResourceColumns) + buildBody(csvData);
    },
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.MASTER_BILLING_RESOURCES) ? undefined : sortOrder,
    selectableRows: 'none',
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.MASTER_BILLING_RESOURCES,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
  }

  // 画面表示
  return (
    <GenericTemplate title="">
      <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={73} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                          platform={""}/>
        {/* ドロワー表示 */}
        <RightDrawer>
          <ApolloMasterBillingEdit billingId={billingId} read={read} setRead={setRead} close={handleClickEditClose} />
        </RightDrawer>

        <Card className={classes.root} square variant="outlined" style={{padding: '10px'}}>
          <Grid xs={12} spacing={0} container>
            <Grid xs={12} md={6}>
              <Typography variant="button" display="block" align="left">
                <Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleClickEditOpen(0)}>
                新規登録
                </Button>
              </Typography>
            </Grid>
            <Grid xs={12} md={6}>
              <Typography variant="button" display="block" align="right">
                <Button className={classes.buttonTop} variant="contained" color="primary" component={Link} to={masterproducts_path} disabled={false}>
                商品マスタ
                </Button>
                <Button className={classes.buttonTop} variant="contained" color="primary" component={Link} to={masterindustorys_path} disabled={false}>
                業種マスタ
                </Button>
                <Button className={classes.buttonTop} variant="contained" color="primary" component={Link} to={masterbillingresources_path} disabled={true}>
                請求マスタ
                </Button>
              </Typography>
            </Grid>
          </Grid>
          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              title=""
              data={rows}
              columns={columns}
              options={
                {
                  ...options,
                  textLabels:{
                    body: {noMatch: "該当データが存在しません"}
                  },
                }
              }
            />
          </Card>
        </Card>
        {/* モーダル表示 */}
        <ApolloMasterReferenceModal index={3} id={clickedReferenceBillingId} open={referenceOpen} setOpen={setReferenceOpen} />
      </ApolloUserProfileAuth>
      {/* メッセージ表示 */}
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

const formatCsvData = (data: any[], tableData: BillingResourceMasterRelation[]): CsvData[] => {
  const dataList: CsvData[] = [];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.billingId === v.data[0]);
      if (!values || values.length === 0) return;
      const d = values[0];
      const list: CsvData = {
        index: v.index,
        data: [
          d.billingId,
          d.billingName,
          `￥${Number(d.creditLimitAmount? d.creditLimitAmount: 0)}`,
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}
